import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "disabled", "onClick", "task"];
import { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { LockedIcon } from 'foundations-assets';
import InviteSeatsContext from 'growth-invite-components/contexts/InviteSeatsContext';
import { useIsPaidPortal } from 'onboarding-scopes';
import UsageLimitPopover from './UsageLimitPopover';
import { QUICK_INVITE_MODAL_PATH, QUICK_INVITE_MODAL_URL } from '../../../utils/urls';
import { useTaskLink } from '../../../hooks/hub';
import { useUserManagementUpgradeKey } from '../../../hooks/upgradeKey';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const QuickInviteTaskButton = _ref => {
  let {
      children,
      disabled,
      onClick,
      task
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [isInviteLimitPopoverOpen, setIsInviteLimitPopoverOpen] = useState(false);
  const isPaidPortal = useIsPaidPortal();
  const history = useHistory();
  const inviteSeats = useContext(InviteSeatsContext);
  const {
    hasInviteSeats = true,
    inUseSeats,
    totalSeats
  } = inviteSeats || {};
  const taskLink = useTaskLink(task.link, task.id, true);
  const userManagementUpgradeKey = useUserManagementUpgradeKey();
  return /*#__PURE__*/_jsx(UsageLimitPopover, {
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.checklist.upgrade.invites.description"
    }),
    onClose: () => setIsInviteLimitPopoverOpen(false),
    open: isInviteLimitPopoverOpen,
    planLimitLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.checklist.upgrade.invites.planLimit",
      options: {
        limitNumber: totalSeats
      }
    }),
    planUsageLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.checklist.upgrade.invites.planUsage",
      options: {
        usedNumber: inUseSeats,
        limitNumber: totalSeats
      }
    }),
    taskKey: task.key,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.checklist.upgrade.invites.title"
    }),
    upgradeCta: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.checklist.upgrade.invites.upgradeCta"
    }),
    upgradeKey: userManagementUpgradeKey,
    usageCurrent: inUseSeats,
    usageLimit: totalSeats,
    children: /*#__PURE__*/_jsxs(Button, Object.assign({
      disabled: disabled,
      href: hasInviteSeats ? QUICK_INVITE_MODAL_URL : undefined,
      onClick: evt => {
        evt.preventDefault();
        if (typeof onClick === 'function') {
          onClick(evt);
        }
        if (!hasInviteSeats) {
          setIsInviteLimitPopoverOpen(true);
        } else {
          if (isPaidPortal && taskLink) {
            window.location.href = `${taskLink}&via=user-guide`;
          } else {
            history.push(QUICK_INVITE_MODAL_PATH);
          }
        }
      }
    }, buttonProps, {
      children: [hasInviteSeats === false && /*#__PURE__*/_jsx(LockedIcon, {}), children]
    }))
  });
};
export default QuickInviteTaskButton;